export var ADDRESS;
(function (ADDRESS) {
    ADDRESS["state"] = "a1";
    ADDRESS["city"] = "a2";
    ADDRESS["street"] = "a3";
    ADDRESS["houseNumber"] = "a4";
    ADDRESS["postalCode"] = "a5";
})(ADDRESS || (ADDRESS = {}));
